import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Layout,
  Row,
  Col,
  Form,
  Tooltip,
  Popconfirm,
  Radio,
  Breadcrumb,
  Spin,
} from "antd";
import { useTranslation } from "react-i18next";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";
const { Content } = Layout;

const PRApprovalHierarchyList = () => {
  const { t } = useTranslation();
  const formRef = useRef();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [PRApprovalList, setPRApprovalList] = useState([]);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
    pr_approval_choices: null,
  });
  const PRApprovalHierarchyGetById = async () => {
    setLoading(true);

    try {
      let apiResponse = await getRequest(
        `pr-release/${CompanyId}/pr-release-by-company/`,
        state
      );

      if (apiResponse.data.success) {
        setState((prevState) => ({
          ...prevState,
          pr_approval_choices: apiResponse.data.pr_approval_choices,
        }));
        formRef.current.setFieldsValue({
          ...state,
          pr_approval_choices: apiResponse.data.pr_approval_choices,
        });
      }
      if (apiResponse.data.data) {
        setPRApprovalList(apiResponse.data.data);
        settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    PRApprovalHierarchyGetById();
  }, []);

  useEffect(() => {
    PRApprovalHierarchyGetById();
  }, [reload]);


  const colors = ["#094E8F"];
  const handleArchive = async (id = "") => {
    try {
      let apiResponse = await postRequest("pr-release-archive/", {
        deleted: [id],
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - id?.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg("PR Release Archived Successfully");
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
        ErrorNotificationMsg(t("error_in_archive_delivery_address"));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };


  const handlePRApprovalChoice = async (fieldName, value) => {
    const payload = {
      pr_approval_choices: value,
    };
    try {
      let apiResponse = await patchRequest(
        "pr-release/pr-release-approva-choices/",
        payload
      );

      if (apiResponse.data.success) {
        settotalCount(apiResponse.data.count);
        PRApprovalHierarchyGetById();
        SuccessNotificationMsg(apiResponse.data.message);
      } else {
        ErrorNotificationMsg(apiResponse.data.message);
      }
    } catch (error) {
      console.error(error);
    }

    if (value === "PR Without Approval") {
      setPRApprovalList([]);
    }
  };

  return (
    <>
         <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              
                <h3>PR Release Hierarchy</h3>
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
    
                  <Breadcrumb.Item>PR Release Hierarchy</Breadcrumb.Item>
                </Breadcrumb>
                </div>
              <div className="pgnmbtns">
                    <Tooltip placement="topRight" title="Archived Records">
                <Link
                  to="/pr-approval-heirarchy/archive"
                  className="Archiveicon"
                >
                  <Archiveicon />
                </Link>
              </Tooltip>
                         </div>
              
            </div>
          </div>
          <div className="stepscontentwrap">
              {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
            {/* <div className="prhirachyiconwrp"></div> */}
            <div className="stepsContent">
              <div className="cardswraper">
                <Spin spinning={loading}>
                  <Form
                    ref={formRef}
                  >
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      className="TextFeild gutter-row"
                    >
                      <h6>PR Approval Choice</h6>
                      <Form.Item
                        className="radioitem radio2"
                        name="pr_approval_choices"
                        rules={[
                          {
                            required: true,
                            message: "Please select an option",
                          },
                        ]}
                        style={{marginBottom:"10px"}}
                      >
                        <Radio.Group
                          className="customrgroup"
                          value={state.pr_approval_choices}
                          onChange={
                            (e) =>
                              handlePRApprovalChoice(
                                "pr_approval_choices",
                                e.target.value
                              ) 
                          }
                        >
                          <Tooltip
                            color={colors}
                            placement="top"
                            title="PR With Approval"
                          >
                            <Radio value="PR With Approval">
                              PR With Approval
                            </Radio>
                          </Tooltip>
                          <Tooltip
                            color={colors}
                            placement="top"
                            title="PR Without Approval"
                          >
                            <Radio value="PR Without Approval">
                              PR Without Approval
                            </Radio>
                          </Tooltip>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  </Form>
                  {state.pr_approval_choices === "PR With Approval" && (
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <div className="stepcard addsite">
                          <div>
                            <Link to="/pr-approval-heirarchy">
                              <PlusCircleOutlined />
                            </Link>
                            <h5>
                              Add Site Wise PR Release <br />
                              Hierarchy
                            </h5>
                          </div>
                        </div>
                      </Col>

                      {PRApprovalList.map((item) => (
                        <Col
                          key={item.id}
                          xs={24}
                          sm={24}
                          md={12}
                          xl={8}
                          xxl={6}
                        >
                          <div className="stepcard sitecard">
                            <div className="cardtitle ">
                              {item.site_name}

                              <div key={item.id} className="action">
                                <Link
                                  to={`/pr-approval-heirarchy/edit/${item.id}`}
                                >
                                  <EditOutlined />
                                </Link>
                                <Popconfirm
                                  className="action"
                                  title={t("pop_title")}
                                  okText={t("pop_ok")}
                                  cancelText={t("pop_cancel")}
                                  onConfirm={() => handleArchive(item.id)}
                                >
                                  <DeleteOutlined />
                                </Popconfirm>
                              </div>
                            </div>
                            {item.pr_second_release && (
                              <div className="hirachycardrow">
                                <div className="hirachysubtitle">
                                  PR Second Release
                                </div>
                                <Row gutter={16}>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>PR Value</label>
                                      <span className="value">
                                        ₹{" "}
                                        {item.pr_second_value_up_to.toLocaleString()}
                                      </span>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>Release Manager </label>
                                      <span className="value">
                                        {
                                          item.pr_second_release_manager
                                            .first_name
                                        }
                                      </span>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </div>
                            )}
                            {item.pr_third_release && (
                              <div className="hirachycardrow">
                                <div className="hirachysubtitle">
                                  PR Third Release
                                </div>
                                <Row gutter={16}>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>PR Value</label>
                                      <span className="value">
                                        ₹{" "}
                                        {item.pr_third_value_up_to.toLocaleString()}
                                      </span>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>Release Manager </label>
                                      <span className="value">
                                        {
                                          item.pr_third_release_manager
                                            .first_name
                                        }
                                      </span>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </div>
                            )}
                            {item.pr_fourth_release && (
                              <div className="hirachycardrow">
                                <div className="hirachysubtitle">
                                  PR Fourth Release
                                </div>
                                <Row gutter={16}>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>PR Value</label>
                                      <span className="value">
                                        ₹{" "}
                                        {item.pr_fourth_value_up_to.toLocaleString()}
                                      </span>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>Release Manager </label>
                                      <span className="value">
                                        {
                                          item.pr_fourth_release_manager
                                            .first_name
                                        }
                                      </span>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </div>
                            )}
                            {item.pr_fifth_release && (
                              <div className="hirachycardrow">
                                <div className="hirachysubtitle">
                                  PR Fifth Release
                                </div>
                                <Row gutter={16}>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>PR Value</label>
                                      <span className="value">
                                        ₹{" "}
                                        {item.pr_fifth_value_up_to.toLocaleString()}
                                      </span>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>Release Manager </label>
                                      <span className="value">
                                        {
                                          item.pr_fifth_release_manager
                                            .first_name
                                        }
                                      </span>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        </Col>
                      ))}
                     
                    </Row>
                  )}
                </Spin>
              </div>
            </div>
          </div>
     
    </>
  );
};

export default PRApprovalHierarchyList;
